import { HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { LoadingService } from '../layout/service/loading.service';

const SKIP_LOADING_PATTERNS = ['/dashboard/'];

@Injectable()
export class LoadingInterceptor {
  private service = inject(LoadingService);


  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (SKIP_LOADING_PATTERNS.some((p) => req.url.includes(p))) {
      return next.handle(req);
    }

    this.service.onStarted(req);
    return next.handle(req).pipe(
      finalize(() => this.service.onFinished(req)),
    );
  }
}
